module.exports = "pegasus_template/assets/tech/email1-gallery-img1.png";